import React, { Suspense, lazy, useEffect, useRef, useState } from 'react';

const Spline = lazy(() => import('@splinetool/react-spline'));

function PreviewMessage({ unavailable = false }) {
  return (
    <div
      role={unavailable ? 'status' : undefined}
      style={{
        width: '100%',
        height: '100%',
        display: 'grid',
        placeItems: 'center',
        padding: 24,
        color: 'rgba(255,255,255,0.78)',
        fontSize: 14,
        textAlign: 'center',
      }}
    >
      {unavailable ? 'Interactive preview is unavailable right now.' : 'Loading interactive preview…'}
    </div>
  );
}

class PreviewErrorBoundary extends React.Component {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error) {
    console.warn('Interactive preview could not load:', error);
  }

  render() {
    return this.state.failed ? <PreviewMessage unavailable /> : this.props.children;
  }
}

export default function SplineModel() {
  const containerRef = useRef(null);
  const [shouldLoad, setShouldLoad] = useState(false);

  useEffect(() => {
    if (!('IntersectionObserver' in window)) {
      setShouldLoad(true);
      return undefined;
    }

    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setShouldLoad(true);
        observer.disconnect();
      }
    }, { rootMargin: '250px' });

    if (containerRef.current) observer.observe(containerRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={containerRef} style={{ width: '100%', height: '100%' }}>
      {shouldLoad ? (
        <PreviewErrorBoundary>
          <Suspense fallback={<PreviewMessage />}>
            <Spline scene="https://prod.spline.design/PNTNLZ3d9HLvRpj7/scene.splinecode">
              <PreviewMessage />
            </Spline>
          </Suspense>
        </PreviewErrorBoundary>
      ) : <PreviewMessage />}
    </div>
  );
}
